// SPDX-License-Identifier: GPL-2.0-or-later
// Formatos e séries do Ranked (OG-250, RN-RKL-01..03, D-41): atributos da sala sobre o mesmo preset
// travado. A série só agrupa jogos; cada jogo é uma ranqueada normal.
export const RANKED_FORMATS = ['2x2', '3x3', '4x4', '5x5'];
export const SERIES_LENGTHS = [1, 3, 5];
export function isRankedFormat(value) {
    return typeof value === 'string' && RANKED_FORMATS.includes(value);
}
export function isSeriesBestOf(value) {
    return typeof value === 'number' && SERIES_LENGTHS.includes(value);
}
/** Jogadores por time (N do NxN). */
export function formatTeamSize(format) {
    return Number(format[0]);
}
/** Tamanho da sala: 2 × N (RN-RKL-01). */
export function formatPlayers(format) {
    return 2 * formatTeamSize(format);
}
/**
 * Linhas de gamemod do formato sobre o preset Ranked travado. 2x2 (D-88, RN-RKL-25): 15 min de tempo
 * normal e a mesma prorrogação de 5 (até os 20); os outros formatos usam o preset como está.
 */
export function formatGamemod(format) {
    return format === '2x2' ? 'time_limit 15\nextra_time 5' : '';
}
/** Bots substitutos por partida (RN-RKL-19): 2 somando os dois times; no 2x2, no máximo 1 por lado (D-88). */
export const MAX_SUBSTITUTES = 2;
export function maxSubstitutesPerSide(format) {
    return format === '2x2' ? 1 : MAX_SUBSTITUTES;
}
/** Vitórias para levar a série: ⌈N/2⌉ (RN-RKL-02). */
export function seriesWinsNeeded(bestOf) {
    return Math.ceil(bestOf / 2);
}
export function newSeries(bestOf) {
    return { bestOf, games: 0, wins: [0, 0] };
}
/** Acaba quando um lado tem a maioria ou depois de N jogos (empates incluídos). */
export function seriesOver(s) {
    const need = seriesWinsNeeded(s.bestOf);
    return s.wins[0] >= need || s.wins[1] >= need || s.games >= s.bestOf;
}
/** Vencedor da série encerrada (null = em andamento ou empatada depois de N jogos). */
export function seriesWinner(s) {
    if (!seriesOver(s) || s.wins[0] === s.wins[1])
        return null;
    return s.wins[0] > s.wins[1] ? 0 : 1;
}
/** Soma um jogo (`winner` null = empate). Série já encerrada não muda. */
export function recordSeriesGame(s, winner) {
    if (seriesOver(s))
        return s;
    const wins = [s.wins[0], s.wins[1]];
    if (winner !== null)
        wins[winner]++;
    return { bestOf: s.bestOf, games: s.games + 1, wins };
}
/**
 * Rotação oficial de mapas (OG-251, RN-RKL-04): uma do Casual, uma por formato do Ranked e a
 * `ranked` das salas Ranked sem formato (anteriores ao lobby).
 */
export const ROTATION_KEYS = ['casual', 'ranked', 'ranked:2x2', 'ranked:3x3', 'ranked:4x4', 'ranked:5x5'];
export function isRotationKey(value) {
    return typeof value === 'string' && ROTATION_KEYS.includes(value);
}
/** Qual rotação oficial a sala usa. */
export function rotationKey(mode, format) {
    return mode === 'ranked' && format ? `ranked:${format}` : mode;
}
//# sourceMappingURL=ranked.js.map